export const EMBED_FIELD = 'embed';
export const VIDEO_THUMBNAIL_FIELD = 'oembed_thumbnail';
export const VIDEO_TYPE_FIELD = 'video_type';
export const HUBSPOT_VIDEO_FIELD = 'hubspot_video';
export const EMBED_URL_FIELD = 'oembed_url';
export const PLAYER_ID_FIELD = 'player_id';